import XAPPService from 'app/Core/services/XAPPService';
export const GET_TAG_FUNCIONALIDADE = '[TAG_FUNCIONALIDADE APP] GET TAG_FUNCIONALIDADE';
export const GETCUSTOM_TAG_FUNCIONALIDADE = '[TAG_FUNCIONALIDADE APP] GET CUSTOM TAG_FUNCIONALIDADE';
export const GET_FUNCIONALIDADE_INDEX = '[TAG_FUNCIONALIDADE APP] GET FUNCIONALIDADE INDEX';
export const GET_FLUXOS_INDEX = '[TAG_FUNCIONALIDADE APP] GET FLUXOS INDEX';
export const OPEN_NEW_TAG_FUNCIONALIDADE_DIALOG = '[TAG_FUNCIONALIDADE APP] OPEN NEW TAG_FUNCIONALIDADE DIALOG';
export const CLOSE_NEW_TAG_FUNCIONALIDADE_DIALOG = '[TAG_FUNCIONALIDADE APP] CLOSE NEW TAG_FUNCIONALIDADE DIALOG';
export const OPEN_EDIT_TAG_FUNCIONALIDADE_DIALOG = '[TAG_FUNCIONALIDADE APP] OPEN EDIT TAG_FUNCIONALIDADE DIALOG';
export const CLOSE_EDIT_TAG_FUNCIONALIDADE_DIALOG = '[TAG_FUNCIONALIDADE APP] CLOSE EDIT TAG_FUNCIONALIDADE DIALOG';
export const REMOVE_TAG_FUNCIONALIDADE = '[TAG_FUNCIONALIDADE APP] REMOVE TAG_FUNCIONALIDADE';
export const ADD_TAG_FUNCIONALIDADE = '[TAG_FUNCIONALIDADE APP] ADD TAG_FUNCIONALIDADE';
export const TAG_FUNCIONALIDADE_WARNING = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE WARNING';
export const TAG_FUNCIONALIDADE_INFO = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE INFO';
export const TAG_FUNCIONALIDADE_ERROR = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE ERROR';
export const TAG_FUNCIONALIDADE_SELECIONAR_WARNING = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE SELECIONAR WARNING';
export const TAG_FUNCIONALIDADE_SELECIONAR_INFO = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE SELECIONAR INFO';
export const TAG_FUNCIONALIDADE_SELECIONAR_ERROR = '[TAG_FUNCIONALIDADE APP] TAG_FUNCIONALIDADE SELECIONAR ERROR';


export const TagFuncionalidadeListState =
    [
        
        'idtagpessoaformulario',       
        'codigo',
        'cor',
        'tipo',
        'tagnome',       
        'tipodescricao',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao'
    ];

const AddState =
    [
        'idtag',
        'idtagfuncionalidade',
        'tipo',
        'subfuncionalidade',
    ];

export function list(_AAction, _AParams, _AID, _ATipo) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "tag.idtag", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        if (_ATipo) {
            AConditionsAND.push({ "Campo": "tipo", "Operador": "=", "Valor": _ATipo });
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAG_FUNCIONALIDADE,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAG_FUNCIONALIDADE_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog(xappRouteParams) {
    return {
        type: OPEN_NEW_TAG_FUNCIONALIDADE_DIALOG,
        xappRouteParams: xappRouteParams
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_TAG_FUNCIONALIDADE_DIALOG
    }
}

export function openEditDialog(data, xappRouteParams) {
    return {
        type: OPEN_EDIT_TAG_FUNCIONALIDADE_DIALOG,
        data,
        xappRouteParams: xappRouteParams
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_TAG_FUNCIONALIDADE_DIALOG
    }
}

export function Error() {
    return {
        type: TAG_FUNCIONALIDADE_ERROR
    }
}

export function save(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = '';

        if (_AValue.idtagfuncionalidade) {
            AConditionsAND = [{ "Campo": "idtagfuncionalidade", "Operador": "=", "Valor": _AValue.idtagfuncionalidade }];
            AAction = "ATUALIZAR";
        }
        else {
            AAction = "INSERIR";
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "tagfuncionalidade", AAction, _AValue, "idtagfuncionalidade", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams)
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: TAG_FUNCIONALIDADE_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: TAG_FUNCIONALIDADE_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
            }

            ).catch(error => {
                return dispatch({
                    type: TAG_FUNCIONALIDADE_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idtagfuncionalidade", "Operador": "=", "Valor": _AValue.idtagfuncionalidade }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "tagfuncionalidade", "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: REMOVE_TAG_FUNCIONALIDADE
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue.idtag)))
            )
            .catch(error => {
                return dispatch({
                    type: TAG_FUNCIONALIDADE_ERROR,
                    payload: error
                });
            });
    };
}

export function GetFuncionalidadeIndex(_AParams) {
    return (dispatch) => {

        XAPPService.XappGetFuncionalidadeIndexAction(_AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_FUNCIONALIDADE_INDEX,
                        payload: response.funcionalidades,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAG_FUNCIONALIDADE_ERROR,
                    payload: error
                });
            });
    }
}

export function clearReducer() {
    return {
        type: GET_TAG_FUNCIONALIDADE,
        payload: null
    }
}

